// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { InvoiceCollectionModel } from "@insite/client-framework/Types/ApiModels";
import InvoicesState from "@store/Framework/Store/Store/Data/Invoices/InvoicesState";
import { Draft } from "immer";

const initialState: InvoicesState = {};

const actions = {
    "Store/Data/Invoices/CompleteLoadInvoices": (
        draft: Draft<InvoicesState>,
        action: { parameter: GetInvoicesApiParameter; collection: InvoiceCollectionModel },
    ) => {
        draft.totalDue = action.collection.totalDue;
        draft.totalPastDue = action.collection.totalPastDue;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type InvoicesActions = Parameters<typeof reducer>[1];
export default reducer;
